import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import HardwareIcon from '@mui/icons-material/Hardware';
import LandscapeIcon from '@mui/icons-material/Landscape';
import PlumbingIcon from '@mui/icons-material/Plumbing';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import ForestIcon from '@mui/icons-material/Forest';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import BuildIcon from '@mui/icons-material/Build';
import ConstructionIcon from '@mui/icons-material/Construction';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import CategoryIcon from '@mui/icons-material/Category';

/**
 * Maps category icon string identifiers to MUI React components.
 * These keys match the ICON_OPTIONS in CategoryFormModal.
 */
const ICON_MAP: Record<string, React.ComponentType<{ sx?: object; className?: string }>> = {
  home: HomeIcon,
  hardware: HardwareIcon,
  landscape: LandscapeIcon,
  plumbing: PlumbingIcon,
  electrical_services: ElectricalServicesIcon,
  forest: ForestIcon,
  water_drop: WaterDropIcon,
  build: BuildIcon,
  construction: ConstructionIcon,
  local_shipping: LocalShippingIcon,
  inventory_2: Inventory2Icon,
  category: CategoryIcon,
};

/**
 * Returns a rendered MUI icon component for a given category icon string.
 * Falls back to CategoryIcon if the icon string is unknown.
 */
export const getCategoryIcon = (
  iconName: string | undefined | null,
  props?: { sx?: object; className?: string },
): React.ReactElement => {
  const IconComponent = ICON_MAP[iconName || 'category'] || CategoryIcon;
  return <IconComponent {...props} />;
};

export default getCategoryIcon;
